export default __webpack_public_path__ + "static/media/Accounts.9c466b9e.svg";